export default __webpack_public_path__ + "static/media/copy.a99ce423.svg";